import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { LatestArticlesFragmentDoc } from '../fragments/LatestArticles.fragment';
import { LatestFeatureArticlesFragmentDoc } from '../fragments/LatestFeatureArticles.fragment';
import { YouTubeShortsFragmentDoc } from '../fragments/YouTubeShorts.fragment';
import { CustomArticle1FragmentDoc } from '../fragments/CustomArticle1.fragment';
import { CustomArticles4FragmentDoc } from '../fragments/CustomArticles4.fragment';
import { W2WArticlesFragmentDoc } from '../fragments/W2WArticles.fragment';
import { StreamingChartsFragmentDoc } from '../fragments/StreamingCharts.fragment';
import { TrendingArticlesFragmentDoc } from '../fragments/TrendingArticles.fragment';
export type GetGuideModulesQueryVariables = Types.Exact<{
	modules?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
	fullPath: Types.Scalars['String']['input'];
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
	streamingChartsFilter?: Types.InputMaybe<Types.StreamingChartsFilter>;
	profile?: Types.InputMaybe<Types.BackdropProfile>;
	format?: Types.InputMaybe<Types.ImageFormat>;
	articlePreview?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	authorImage?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	authorPreview?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	linkedObjects?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	first: Types.Scalars['Int']['input'];
	filter?: Types.InputMaybe<Types.TitleFilter>;
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	withOffers?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetGuideModulesQuery = {
	__typename?: 'Query';
	urlV2: {
		__typename?: 'Url';
		id: string;
		node:
			| { __typename?: 'Article' }
			| { __typename?: 'Author' }
			| { __typename?: 'Bundle' }
			| { __typename?: 'Device' }
			| { __typename?: 'Episode' }
			| { __typename?: 'GenericTitleList' }
			| { __typename?: 'Genre' }
			| {
					__typename?: 'HomePage';
					modules: Array<
						| { __typename?: 'HMAVOD' }
						| { __typename?: 'HMBecauseYouLikedTitle' }
						| { __typename?: 'HMCinemaMostAnticipated' }
						| { __typename?: 'HMContinueWatching' }
						| { __typename?: 'HMContinueWatchingJWTV' }
						| { __typename?: 'HMCustomArticle1' }
						| { __typename?: 'HMCustomArticles4' }
						| { __typename?: 'HMCustomTitle1' }
						| { __typename?: 'HMDistributor' }
						| { __typename?: 'HMFeatureRotator' }
						| { __typename?: 'HMHighlightArticle' }
						| { __typename?: 'HMJWTVWithHighIMDBRating' }
						| { __typename?: 'HMLatestArticles' }
						| { __typename?: 'HMLatestFeatureArticles' }
						| { __typename?: 'HMNewOnJWTV' }
						| { __typename?: 'HMNewPerPackageToday' }
						| { __typename?: 'HMPermanentAudience' }
						| { __typename?: 'HMPrimeSports' }
						| {
								__typename?: 'HMRow';
								layout: Types.ModuleLayout;
								modules: Array<
									| { __typename?: 'HMAVOD'; layout: Types.ModuleLayout }
									| { __typename?: 'HMBecauseYouLikedTitle'; layout: Types.ModuleLayout }
									| { __typename?: 'HMCinemaMostAnticipated'; layout: Types.ModuleLayout }
									| { __typename?: 'HMContinueWatching'; layout: Types.ModuleLayout }
									| { __typename?: 'HMContinueWatchingJWTV'; layout: Types.ModuleLayout }
									| {
											__typename?: 'HMCustomArticle1';
											layout: Types.ModuleLayout;
											category: string;
											moduleID: number;
											type: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
											article?: {
												__typename: 'Article';
												id: string;
												content: {
													__typename?: 'ArticleContent';
													snippet?: string | null;
													id: number;
													fullPath: string;
													title?: string | null;
													articleType: Types.ArticleType;
													updatedAt: any;
													createdAt: any;
													subtitle?: string | null;
													paragraph1?: string | null;
													paragraph2?: string | null;
													synopsis?: string | null;
													whereToWatch?: string | null;
													whatToKnow?: string | null;
													productionNews?: string | null;
													titleOrderMode?: string;
													isLegacy?: boolean;
													relatedVideos?: Array<string>;
													headerImage?: {
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
													} | null;
													mainImageEntityBackdrop?: {
														__typename?: 'Backdrop';
														backdropUrl: string;
													} | null;
													images?: Array<{
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
														blurHash: string;
														imageType: string;
														language?: string | null;
													}> | null;
												};
												author: {
													__typename?: 'Author';
													id: string;
													content: {
														__typename?: 'AuthorContent';
														clearName: string;
														imageUrl?: string | null;
														fullPath: string;
														bio?: string;
														alumniOf?: Array<string>;
														brand?: string;
														languagesSpoken?: Array<any>;
														occupation?: Array<string>;
														publications?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
														socialHandles?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
													};
												};
												mainObjects: Array<{
													__typename: 'ArticleLinkedObject';
													node:
														| { __typename: 'Article' }
														| { __typename: 'Author' }
														| { __typename: 'Bundle' }
														| { __typename: 'Device' }
														| { __typename: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename: 'Genre' }
														| { __typename: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'MultiStepSportEvent' }
														| { __typename: 'Offer' }
														| { __typename: 'OfferHistory' }
														| { __typename: 'Package' }
														| { __typename: 'Page' }
														| { __typename: 'Person' }
														| { __typename: 'PressRelease' }
														| { __typename: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'SingleStepSportEvent' }
														| { __typename: 'SportCompetitionV2' }
														| { __typename: 'SportCompetitorV2' }
														| { __typename: 'SportMatch' }
														| { __typename: 'Url' }
														| { __typename: 'UserProviderSubscription' };
												}>;
												secondaryObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
												supportingObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| { __typename?: 'Season' }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
											} | null;
									  }
									| {
											__typename?: 'HMCustomArticles4';
											layout: Types.ModuleLayout;
											category: string;
											moduleID: number;
											type: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
											articles: Array<{
												__typename: 'Article';
												id: string;
												author: {
													__typename?: 'Author';
													id: string;
													content: {
														__typename?: 'AuthorContent';
														clearName: string;
														imageUrl?: string | null;
														fullPath: string;
														bio?: string;
														alumniOf?: Array<string>;
														brand?: string;
														languagesSpoken?: Array<any>;
														occupation?: Array<string>;
														publications?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
														socialHandles?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
													};
												};
												content: {
													__typename?: 'ArticleContent';
													id: number;
													fullPath: string;
													title?: string | null;
													articleType: Types.ArticleType;
													updatedAt: any;
													createdAt: any;
													subtitle?: string | null;
													paragraph1?: string | null;
													paragraph2?: string | null;
													synopsis?: string | null;
													whereToWatch?: string | null;
													whatToKnow?: string | null;
													productionNews?: string | null;
													titleOrderMode?: string;
													isLegacy?: boolean;
													relatedVideos?: Array<string>;
													headerImage?: {
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
													} | null;
													mainImageEntityBackdrop?: {
														__typename?: 'Backdrop';
														backdropUrl: string;
													} | null;
													images?: Array<{
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
														blurHash: string;
														imageType: string;
														language?: string | null;
													}> | null;
												};
												mainObjects: Array<{
													__typename: 'ArticleLinkedObject';
													node:
														| { __typename: 'Article' }
														| { __typename: 'Author' }
														| { __typename: 'Bundle' }
														| { __typename: 'Device' }
														| { __typename: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename: 'Genre' }
														| { __typename: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'MultiStepSportEvent' }
														| { __typename: 'Offer' }
														| { __typename: 'OfferHistory' }
														| { __typename: 'Package' }
														| { __typename: 'Page' }
														| { __typename: 'Person' }
														| { __typename: 'PressRelease' }
														| { __typename: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'SingleStepSportEvent' }
														| { __typename: 'SportCompetitionV2' }
														| { __typename: 'SportCompetitorV2' }
														| { __typename: 'SportMatch' }
														| { __typename: 'Url' }
														| { __typename: 'UserProviderSubscription' };
												}>;
												secondaryObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
												supportingObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| { __typename?: 'Season' }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
											}>;
									  }
									| { __typename?: 'HMCustomTitle1'; layout: Types.ModuleLayout }
									| { __typename?: 'HMDistributor'; layout: Types.ModuleLayout }
									| { __typename?: 'HMFeatureRotator'; layout: Types.ModuleLayout }
									| { __typename?: 'HMHighlightArticle'; layout: Types.ModuleLayout }
									| { __typename?: 'HMJWTVWithHighIMDBRating'; layout: Types.ModuleLayout }
									| {
											__typename?: 'HMLatestArticles';
											layout: Types.ModuleLayout;
											category: string;
											moduleID: number;
											type: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												badge: string;
												title: string;
											};
											articles: Array<{
												__typename: 'Article';
												id: string;
												author: {
													__typename?: 'Author';
													id: string;
													content: {
														__typename?: 'AuthorContent';
														clearName: string;
														imageUrl?: string | null;
														fullPath: string;
														bio?: string;
														alumniOf?: Array<string>;
														brand?: string;
														languagesSpoken?: Array<any>;
														occupation?: Array<string>;
														publications?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
														socialHandles?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
													};
												};
												content: {
													__typename?: 'ArticleContent';
													id: number;
													fullPath: string;
													title?: string | null;
													articleType: Types.ArticleType;
													updatedAt: any;
													createdAt: any;
													subtitle?: string | null;
													paragraph1?: string | null;
													paragraph2?: string | null;
													synopsis?: string | null;
													whereToWatch?: string | null;
													whatToKnow?: string | null;
													productionNews?: string | null;
													titleOrderMode?: string;
													isLegacy?: boolean;
													relatedVideos?: Array<string>;
													headerImage?: {
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
													} | null;
													mainImageEntityBackdrop?: {
														__typename?: 'Backdrop';
														backdropUrl: string;
													} | null;
													images?: Array<{
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
														blurHash: string;
														imageType: string;
														language?: string | null;
													}> | null;
												};
												mainObjects: Array<{
													__typename: 'ArticleLinkedObject';
													node:
														| { __typename: 'Article' }
														| { __typename: 'Author' }
														| { __typename: 'Bundle' }
														| { __typename: 'Device' }
														| { __typename: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename: 'Genre' }
														| { __typename: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'MultiStepSportEvent' }
														| { __typename: 'Offer' }
														| { __typename: 'OfferHistory' }
														| { __typename: 'Package' }
														| { __typename: 'Page' }
														| { __typename: 'Person' }
														| { __typename: 'PressRelease' }
														| { __typename: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'SingleStepSportEvent' }
														| { __typename: 'SportCompetitionV2' }
														| { __typename: 'SportCompetitorV2' }
														| { __typename: 'SportMatch' }
														| { __typename: 'Url' }
														| { __typename: 'UserProviderSubscription' };
												}>;
												secondaryObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
												supportingObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| { __typename?: 'Season' }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
											}>;
									  }
									| {
											__typename?: 'HMLatestFeatureArticles';
											layout: Types.ModuleLayout;
											category: string;
											moduleID: number;
											type: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												badge: string;
												title: string;
											};
											articles: Array<{
												__typename: 'Article';
												id: string;
												content: {
													__typename?: 'ArticleContent';
													snippet?: string | null;
													id: number;
													fullPath: string;
													title?: string | null;
													articleType: Types.ArticleType;
													updatedAt: any;
													createdAt: any;
													subtitle?: string | null;
													paragraph1?: string | null;
													paragraph2?: string | null;
													synopsis?: string | null;
													whereToWatch?: string | null;
													whatToKnow?: string | null;
													productionNews?: string | null;
													titleOrderMode?: string;
													isLegacy?: boolean;
													relatedVideos?: Array<string>;
													headerImage?: {
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
													} | null;
													mainImageEntityBackdrop?: {
														__typename?: 'Backdrop';
														backdropUrl: string;
													} | null;
													images?: Array<{
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
														blurHash: string;
														imageType: string;
														language?: string | null;
													}> | null;
												};
												author: {
													__typename?: 'Author';
													id: string;
													content: {
														__typename?: 'AuthorContent';
														clearName: string;
														imageUrl?: string | null;
														fullPath: string;
														bio?: string;
														alumniOf?: Array<string>;
														brand?: string;
														languagesSpoken?: Array<any>;
														occupation?: Array<string>;
														publications?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
														socialHandles?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
													};
												};
												mainObjects: Array<{
													__typename: 'ArticleLinkedObject';
													node:
														| { __typename: 'Article' }
														| { __typename: 'Author' }
														| { __typename: 'Bundle' }
														| { __typename: 'Device' }
														| { __typename: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename: 'Genre' }
														| { __typename: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'MultiStepSportEvent' }
														| { __typename: 'Offer' }
														| { __typename: 'OfferHistory' }
														| { __typename: 'Package' }
														| { __typename: 'Page' }
														| { __typename: 'Person' }
														| { __typename: 'PressRelease' }
														| { __typename: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'SingleStepSportEvent' }
														| { __typename: 'SportCompetitionV2' }
														| { __typename: 'SportCompetitorV2' }
														| { __typename: 'SportMatch' }
														| { __typename: 'Url' }
														| { __typename: 'UserProviderSubscription' };
												}>;
												secondaryObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
												supportingObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| { __typename?: 'Season' }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
											}>;
									  }
									| { __typename?: 'HMNewOnJWTV'; layout: Types.ModuleLayout }
									| { __typename?: 'HMNewPerPackageToday'; layout: Types.ModuleLayout }
									| { __typename?: 'HMPermanentAudience'; layout: Types.ModuleLayout }
									| { __typename?: 'HMPrimeSports'; layout: Types.ModuleLayout }
									| { __typename?: 'HMRow'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSQTV'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSimilarLikedOnJWTV'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSportsLiveFootball'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSportsUpcomingFootball'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSpotlight'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSpotlightContinueWatching'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSpotlightGoingViral'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSpotlightNewOnYourWatchlist'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSpotlightNewSimilarToLikedTitle'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSpotlightNewWithHighRatings'; layout: Types.ModuleLayout }
									| { __typename?: 'HMSpotlightTrendingToday'; layout: Types.ModuleLayout }
									| {
											__typename?: 'HMStreamingCharts';
											layout: Types.ModuleLayout;
											category: string;
											moduleID: number;
											type: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												badge: string;
												title: string;
											};
											titles: Array<
												| {
														__typename?: 'Movie';
														id: string;
														content: {
															__typename?: 'MovieContent';
															title: string;
															fullPath: string;
															posterUrl?: string | null;
														};
														streamingCharts: {
															__typename?: 'StreamingChartsConnection';
															edges?: Array<{
																__typename?: 'StreamingChartsTitlesEdge';
																streamingChartInfo?: {
																	__typename?: 'StreamingChartInfo';
																	rank: number;
																	trend: Types.ModuleContentTitleTrend;
																	trendDifference: number;
																} | null;
															}> | null;
														};
												  }
												| {
														__typename?: 'Season';
														id: string;
														content: {
															__typename?: 'SeasonContent';
															title: string;
															fullPath: string;
															posterUrl?: string | null;
														};
														streamingCharts: {
															__typename?: 'StreamingChartsConnection';
															edges?: Array<{
																__typename?: 'StreamingChartsTitlesEdge';
																streamingChartInfo?: {
																	__typename?: 'StreamingChartInfo';
																	rank: number;
																	trend: Types.ModuleContentTitleTrend;
																	trendDifference: number;
																} | null;
															}> | null;
														};
												  }
												| {
														__typename?: 'Show';
														id: string;
														content: {
															__typename?: 'ShowContent';
															title: string;
															fullPath: string;
															posterUrl?: string | null;
														};
														streamingCharts: {
															__typename?: 'StreamingChartsConnection';
															edges?: Array<{
																__typename?: 'StreamingChartsTitlesEdge';
																streamingChartInfo?: {
																	__typename?: 'StreamingChartInfo';
																	rank: number;
																	trend: Types.ModuleContentTitleTrend;
																	trendDifference: number;
																} | null;
															}> | null;
														};
												  }
											>;
									  }
									| { __typename?: 'HMTVOD'; layout: Types.ModuleLayout }
									| { __typename?: 'HMTextRecommendation'; layout: Types.ModuleLayout }
									| { __typename?: 'HMTop3PerPackageToday'; layout: Types.ModuleLayout }
									| { __typename?: 'HMTop10InYourCountry'; layout: Types.ModuleLayout }
									| { __typename?: 'HMTopGenre'; layout: Types.ModuleLayout }
									| { __typename?: 'HMTopHighlightArticle'; layout: Types.ModuleLayout }
									| { __typename?: 'HMTrendingAndStreamingOnJWTForFree'; layout: Types.ModuleLayout }
									| {
											__typename?: 'HMTrendingArticles';
											layout: Types.ModuleLayout;
											category: string;
											moduleID: number;
											type: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
											articles: Array<{
												__typename: 'Article';
												id: string;
												author: {
													__typename?: 'Author';
													id: string;
													content: {
														__typename?: 'AuthorContent';
														clearName: string;
														imageUrl?: string | null;
														fullPath: string;
														bio?: string;
														alumniOf?: Array<string>;
														brand?: string;
														languagesSpoken?: Array<any>;
														occupation?: Array<string>;
														publications?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
														socialHandles?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
													};
												};
												content: {
													__typename?: 'ArticleContent';
													id: number;
													fullPath: string;
													title?: string | null;
													articleType: Types.ArticleType;
													updatedAt: any;
													createdAt: any;
													subtitle?: string | null;
													paragraph1?: string | null;
													paragraph2?: string | null;
													synopsis?: string | null;
													whereToWatch?: string | null;
													whatToKnow?: string | null;
													productionNews?: string | null;
													titleOrderMode?: string;
													isLegacy?: boolean;
													relatedVideos?: Array<string>;
													headerImage?: {
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
													} | null;
													mainImageEntityBackdrop?: {
														__typename?: 'Backdrop';
														backdropUrl: string;
													} | null;
													images?: Array<{
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
														blurHash: string;
														imageType: string;
														language?: string | null;
													}> | null;
												};
												mainObjects: Array<{
													__typename: 'ArticleLinkedObject';
													node:
														| { __typename: 'Article' }
														| { __typename: 'Author' }
														| { __typename: 'Bundle' }
														| { __typename: 'Device' }
														| { __typename: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename: 'Genre' }
														| { __typename: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'MultiStepSportEvent' }
														| { __typename: 'Offer' }
														| { __typename: 'OfferHistory' }
														| { __typename: 'Package' }
														| { __typename: 'Page' }
														| { __typename: 'Person' }
														| { __typename: 'PressRelease' }
														| { __typename: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'SingleStepSportEvent' }
														| { __typename: 'SportCompetitionV2' }
														| { __typename: 'SportCompetitorV2' }
														| { __typename: 'SportMatch' }
														| { __typename: 'Url' }
														| { __typename: 'UserProviderSubscription' };
												}>;
												secondaryObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
												supportingObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| { __typename?: 'Season' }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
											}>;
									  }
									| { __typename?: 'HMVideoFeed'; layout: Types.ModuleLayout }
									| {
											__typename?: 'HMW2WArticles';
											layout: Types.ModuleLayout;
											category: string;
											moduleID: number;
											type: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
											articles: Array<{
												__typename: 'Article';
												id: string;
												content: {
													__typename?: 'ArticleContent';
													snippet?: string | null;
													id: number;
													fullPath: string;
													title?: string | null;
													articleType: Types.ArticleType;
													updatedAt: any;
													createdAt: any;
													subtitle?: string | null;
													paragraph1?: string | null;
													paragraph2?: string | null;
													synopsis?: string | null;
													whereToWatch?: string | null;
													whatToKnow?: string | null;
													productionNews?: string | null;
													titleOrderMode?: string;
													isLegacy?: boolean;
													relatedVideos?: Array<string>;
													headerImage?: {
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
													} | null;
													mainImageEntityBackdrop?: {
														__typename?: 'Backdrop';
														backdropUrl: string;
													} | null;
													images?: Array<{
														__typename?: 'ArticleImage';
														url: string;
														altText: string;
														blurHash: string;
														imageType: string;
														language?: string | null;
													}> | null;
												};
												author: {
													__typename?: 'Author';
													id: string;
													content: {
														__typename?: 'AuthorContent';
														clearName: string;
														imageUrl?: string | null;
														fullPath: string;
														bio?: string;
														alumniOf?: Array<string>;
														brand?: string;
														languagesSpoken?: Array<any>;
														occupation?: Array<string>;
														publications?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
														socialHandles?: Array<{
															__typename?: 'AuthorSpecificLink';
															name: string;
															url: string;
														}> | null;
													};
												};
												mainObjects: Array<{
													__typename: 'ArticleLinkedObject';
													node:
														| { __typename: 'Article' }
														| { __typename: 'Author' }
														| { __typename: 'Bundle' }
														| { __typename: 'Device' }
														| { __typename: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename: 'Genre' }
														| { __typename: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'MultiStepSportEvent' }
														| { __typename: 'Offer' }
														| { __typename: 'OfferHistory' }
														| { __typename: 'Package' }
														| { __typename: 'Page' }
														| { __typename: 'Person' }
														| { __typename: 'PressRelease' }
														| { __typename: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename: 'SingleStepSportEvent' }
														| { __typename: 'SportCompetitionV2' }
														| { __typename: 'SportCompetitorV2' }
														| { __typename: 'SportMatch' }
														| { __typename: 'Url' }
														| { __typename: 'UserProviderSubscription' };
												}>;
												secondaryObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'SeasonContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
												supportingObjects: Array<{
													__typename?: 'ArticleLinkedObject';
													node:
														| { __typename?: 'Article' }
														| { __typename?: 'Author' }
														| { __typename?: 'Bundle' }
														| { __typename?: 'Device' }
														| { __typename?: 'Episode' }
														| {
																__typename: 'GenericTitleList';
																id: string;
																content: {
																	__typename?: 'GenericTitleListContent';
																	name: string;
																};
																followedlistEntry?: {
																	__typename?: 'FollowedListEntry';
																	createdAt: any;
																} | null;
																titles: {
																	__typename?: 'GenericTitleListConnection';
																	totalCount: number;
																	pageInfo: {
																		__typename?: 'PageInfo';
																		endCursor: string;
																		hasNextPage: boolean;
																		hasPreviousPage: boolean;
																		startCursor: string;
																	};
																	edges?: Array<{
																		__typename?: 'GenericTitleListEdge';
																		data: {
																			__typename?: 'TitleListEntryData';
																			overrides?: Array<{
																				__typename?: 'TitleListEntryDataOverride';
																				languageOrLocale: string;
																				shortDescription?: string | null;
																				title?: string | null;
																				titleHeaderImage?: {
																					__typename?: 'ArticleImage';
																					url: string;
																					altText: string;
																				} | null;
																			}> | null;
																		};
																		node:
																			| {
																					__typename: 'Movie';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenlistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					content: {
																						__typename?: 'MovieContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  }
																			| {
																					__typename: 'Show';
																					id: string;
																					objectId: number;
																					objectType: Types.ObjectType;
																					seenState: {
																						__typename?: 'ShowSeenState';
																						progress: number;
																						seenEpisodeCount: number;
																					};
																					content: {
																						__typename?: 'ShowContent';
																						title: string;
																						fullPath: string;
																						originalReleaseYear?:
																							| number
																							| null;
																						shortDescription?:
																							| string
																							| null;
																						posterUrl?: string | null;
																						scoring: {
																							__typename?: 'Scoring';
																							imdbScore?: number | null;
																							imdbVotes?: number | null;
																							tmdbPopularity?:
																								| number
																								| null;
																							tmdbScore?: number | null;
																						};
																						backdrops: Array<{
																							__typename?: 'Backdrop';
																							backdropUrl: string;
																						}>;
																					};
																					watchlistEntryV2?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					likelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					dislikelistEntry?: {
																						__typename?: 'TitleListEntry';
																						createdAt: any;
																					} | null;
																					offers?: Array<{
																						__typename?: 'Offer';
																						id: string;
																						currency?: string | null;
																						monetizationType: Types.MonetizationType;
																						presentationType: Types.PresentationType;
																						retailPrice?: string | null;
																						standardWebURL?: string | null;
																						preAffiliatedStandardWebURL?:
																							| string
																							| null;
																						package: {
																							__typename?: 'Package';
																							shortName: string;
																							id: string;
																						};
																					}>;
																			  };
																	}> | null;
																};
														  }
														| { __typename?: 'Genre' }
														| { __typename?: 'HomePage' }
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'MovieContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'MovieContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'MultiStepSportEvent' }
														| { __typename?: 'Offer' }
														| { __typename?: 'OfferHistory' }
														| { __typename?: 'Package' }
														| { __typename?: 'Page' }
														| { __typename?: 'Person' }
														| { __typename?: 'PressRelease' }
														| { __typename?: 'ProfileV2' }
														| { __typename?: 'Season' }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																watchlistEntryV2?: {
																	__typename?: 'TitleListEntry';
																	createdAt: any;
																} | null;
																content: {
																	__typename?: 'ShowContent';
																	title: string;
																	fullPath: string;
																	originalReleaseYear?: number | null;
																	runtime?: number | null;
																	posterUrl?: string | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	genres: Array<{
																		__typename?: 'Genre';
																		shortName: string;
																	}>;
																	scoring: {
																		__typename?: 'Scoring';
																		imdbScore?: number | null;
																		imdbVotes?: number | null;
																		tmdbPopularity?: number | null;
																		tmdbScore?: number | null;
																	};
																	externalIds: {
																		__typename?: 'ExternalIds';
																		imdbId?: string | null;
																	};
																	backdrops: Array<{
																		__typename?: 'Backdrop';
																		backdropUrl: string;
																	}>;
																	clips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																fallBackClips: {
																	__typename?: 'ShowContent';
																	videobusterClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																	dailymotionClips: Array<{
																		__typename?: 'Clip';
																		sourceUrl: string;
																		externalId: string;
																		provider: Types.ClipProvider;
																	}>;
																};
																watchNowOffer?: {
																	__typename: 'Offer';
																	id: string;
																	standardWebURL?: string | null;
																	preAffiliatedStandardWebURL?: string | null;
																	streamUrl?: string | null;
																	streamUrlExternalPlayer?: string | null;
																	retailPrice?: string | null;
																	retailPriceValue?: number | null;
																	lastChangeRetailPriceValue?: number | null;
																	currency?: string | null;
																	presentationType: Types.PresentationType;
																	monetizationType: Types.MonetizationType;
																	availableTo?: any | null;
																	dateCreated?: any | null;
																	newElementCount?: number | null;
																	mediaDealId?: number | null;
																	package: {
																		__typename?: 'Package';
																		id: string;
																		icon: string;
																		packageId: number;
																		clearName: string;
																		shortName: string;
																		technicalName: string;
																		iconWide: string;
																		hasRectangularIcon: boolean;
																	};
																} | null;
														  }
														| { __typename?: 'SingleStepSportEvent' }
														| { __typename?: 'SportCompetitionV2' }
														| { __typename?: 'SportCompetitorV2' }
														| { __typename?: 'SportMatch' }
														| { __typename?: 'Url' }
														| { __typename?: 'UserProviderSubscription' };
												}>;
											}>;
									  }
									| { __typename?: 'HMWatchedBySimilarUsers'; layout: Types.ModuleLayout }
									| { __typename?: 'HMYourJWTVWatchlist'; layout: Types.ModuleLayout }
									| {
											__typename?: 'HMYoutubeShorts';
											layout: Types.ModuleLayout;
											category: string;
											moduleID: number;
											type: string;
											urls: Array<string>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												badge: string;
												title: string;
											};
									  }
								>;
						  }
						| { __typename?: 'HMSQTV' }
						| { __typename?: 'HMSimilarLikedOnJWTV' }
						| { __typename?: 'HMSportsLiveFootball' }
						| { __typename?: 'HMSportsUpcomingFootball' }
						| { __typename?: 'HMSpotlight' }
						| { __typename?: 'HMSpotlightContinueWatching' }
						| { __typename?: 'HMSpotlightGoingViral' }
						| { __typename?: 'HMSpotlightNewOnYourWatchlist' }
						| { __typename?: 'HMSpotlightNewSimilarToLikedTitle' }
						| { __typename?: 'HMSpotlightNewWithHighRatings' }
						| { __typename?: 'HMSpotlightTrendingToday' }
						| { __typename?: 'HMStreamingCharts' }
						| { __typename?: 'HMTVOD' }
						| { __typename?: 'HMTextRecommendation' }
						| { __typename?: 'HMTop3PerPackageToday' }
						| { __typename?: 'HMTop10InYourCountry' }
						| { __typename?: 'HMTopGenre' }
						| { __typename?: 'HMTopHighlightArticle' }
						| { __typename?: 'HMTrendingAndStreamingOnJWTForFree' }
						| { __typename?: 'HMTrendingArticles' }
						| { __typename?: 'HMVideoFeed' }
						| { __typename?: 'HMW2WArticles' }
						| { __typename?: 'HMWatchedBySimilarUsers' }
						| { __typename?: 'HMYourJWTVWatchlist' }
						| { __typename?: 'HMYoutubeShorts' }
						| null
					>;
			  }
			| { __typename?: 'Movie' }
			| { __typename?: 'MultiStepSportEvent' }
			| { __typename?: 'Offer' }
			| { __typename?: 'OfferHistory' }
			| { __typename?: 'Package' }
			| { __typename?: 'Page' }
			| { __typename?: 'Person' }
			| { __typename?: 'PressRelease' }
			| { __typename?: 'ProfileV2' }
			| { __typename?: 'Season' }
			| { __typename?: 'Show' }
			| { __typename?: 'SingleStepSportEvent' }
			| { __typename?: 'SportCompetitionV2' }
			| { __typename?: 'SportCompetitorV2' }
			| { __typename?: 'SportMatch' }
			| { __typename?: 'Url' }
			| { __typename?: 'UserProviderSubscription' };
	};
};

export const GetGuideModulesDocument = gql`
	query GetGuideModules(
		$modules: [String!]
		$fullPath: String!
		$country: Country!
		$language: Language!
		$site: String
		$streamingChartsFilter: StreamingChartsFilter
		$profile: BackdropProfile
		$format: ImageFormat
		$articlePreview: Boolean = true
		$authorImage: Boolean = false
		$authorPreview: Boolean = true
		$linkedObjects: Boolean = false
		$first: Int!
		$filter: TitleFilter
		$after: String
		$withOffers: Boolean = false
	) {
		urlV2(fullPath: $fullPath, site: $site) {
			id
			node {
				... on HomePage {
					modules(modules: $modules) {
						... on HMRow {
							layout
							modules {
								layout
								...LatestArticles
								...LatestFeatureArticles
								...YouTubeShorts
								...CustomArticle1
								...CustomArticles4
								...W2WArticles
								...StreamingCharts
								...TrendingArticles
							}
						}
					}
				}
			}
		}
	}
	${LatestArticlesFragmentDoc}
	${LatestFeatureArticlesFragmentDoc}
	${YouTubeShortsFragmentDoc}
	${CustomArticle1FragmentDoc}
	${CustomArticles4FragmentDoc}
	${W2WArticlesFragmentDoc}
	${StreamingChartsFragmentDoc}
	${TrendingArticlesFragmentDoc}
`;
